import { useEffect, useRef, useState } from "react";
import { Send, Loader2, Plus } from "lucide-react";
import { api } from "../lib/api";

const newId = () => `conv_${Date.now().toString(36)}`;
const STORE = "tsm-admin-conv";

export const TripDesigner = () => {
  const [conv, setConv] = useState(() => localStorage.getItem(STORE) || newId());
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    localStorage.setItem(STORE, conv);
    api.get(`/admin/chat/${conv}`).then((r) => setMsgs(Array.isArray(r.data) ? r.data : [])).catch(() => setMsgs([]));
  }, [conv]);

  useEffect(() => { endRef.current?.scrollIntoView({ block: "end" }); }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    const message = text.trim();
    if (!message || busy) return;
    setText("");
    setBusy(true);
    setMsgs((m) => [...m, { role: "user", content: message }, { role: "assistant", content: "" }]);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/chat`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ conversation_id: conv, message }),
      });
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          const raw = p.replace(/^data: /, "");
          if (raw === "[DONE]") continue;
          const ev = JSON.parse(raw);
          const add = ev.delta ?? (ev.error ? `\n[Errore: ${ev.error}]` : "");
          setMsgs((m) => { const c = [...m]; c[c.length - 1] = { ...c[c.length - 1], content: c[c.length - 1].content + add }; return c; });
        }
      }
    } catch {
      setMsgs((m) => { const c = [...m]; c[c.length - 1] = { role: "assistant", content: "[Errore di connessione]" }; return c; });
    }
    setBusy(false);
  };

  return (
    <div className="border border-[#D4AF37]/20 bg-[#14120E] flex flex-col h-[640px]" data-testid="trip-designer">
      <div className="flex items-center justify-between px-5 py-4 border-b border-[#D4AF37]/15">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">Claude · Trip designer</p>
          <p className="text-xs text-[#B5AC9C] mt-1">Bozze di itinerari e risposte ai clienti (IT/FR/EN)</p>
        </div>
        <button onClick={() => { setConv(newId()); }} className="btn-ghost !py-2 !px-3" data-testid="chat-new-btn"><Plus size={14} /> Nuova</button>
      </div>
      <div className="flex-1 overflow-y-auto p-5 space-y-4" data-lenis-prevent data-testid="chat-messages">
        {msgs.length === 0 && <p className="text-sm text-[#B5AC9C]">Es. "Proponi un tour enduro di 6 giorni Douz → Ksar Ghilane per 8 piloti esperti, in francese."</p>}
        {msgs.map((m, i) => (
          <div key={i} className={`max-w-[85%] whitespace-pre-wrap text-sm leading-relaxed px-4 py-3 ${m.role === "user" ? "ml-auto bg-[#D4AF37] text-[#0B0A08]" : "bg-[#1A1713] text-[#F7F4EE] border border-[#D4AF37]/10"}`} data-testid={`chat-msg-${m.role}`}>
            {m.content || <Loader2 size={16} className="animate-spin text-[#D4AF37]" />}
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="flex gap-2 p-4 border-t border-[#D4AF37]/15">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi una richiesta…" className="flex-1 bg-[#0B0A08] border border-[#D4AF37]/25 px-4 py-3 text-sm text-[#F7F4EE] outline-none focus:border-[#D4AF37]" data-testid="chat-input" />
        <button type="submit" disabled={busy} className="btn-gold !px-4" data-testid="chat-send-btn">{busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}</button>
      </form>
    </div>
  );
};
